import { render, staticRenderFns } from "./WCards.vue?vue&type=template&id=2948527c&"
import script from "./WCards.vue?vue&type=script&lang=ts&"
export * from "./WCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports